// Add ... to a text of more than 50 characters
export const max50Caracters = (text: string): string => {
  return text.length > 50 ? text.substring(0, 50) + '...' : text;
};
